import React, { useEffect, useState } from 'react';

const Header = () => {
  const [importedComponent, setImportedComponent] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const importComponent = async () => {
      /* Dynamically load MMT-UI-Header component for Bigger Screen Size ONLY */
      const module = await import('pwa-mmt-ui-header/ssr/header');
      const MMTHeaderComponent = module.Header;
      setImportedComponent(<MMTHeaderComponent selectedTabName={'Buses'} />);
    };

    !isSmallScreen && importComponent();
  }, [isSmallScreen]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleScreenSize);

    return () => {
      window.removeEventListener('resize', handleScreenSize);
    };
  }, []);

  if (typeof window === 'undefined') {
    return <></>;
  }

  return <>{importedComponent}</>;
};

export default Header;
